import { ApiCore, iApiCore } from '@healthme/services/api/utilities/Core';

interface iStaffAccounts extends iApiCore {}
/*
 **-------------------------------------------------------------------------------------
 ** METHOD NAME - analytics Class
 **-------------------------------------------------------------------------------------
 */
class StaffAccounts extends ApiCore {}

/*
 **-------------------------------------------------------------------------------------
 ** METHOD NAME - analytics
 **-------------------------------------------------------------------------------------
 */
const staffAccounts: iStaffAccounts = new StaffAccounts({
	url: 'staff_accounts',
});



export default staffAccounts;
